import React from 'react'
import { IonCol, IonGrid, IonRow, IonSpinner } from '@ionic/react'
import { useEffect } from 'react'
import Patientcard from './components/patientcard/patientcard'
import { useAppData } from '../../context/appContext';
import "./patientdashboard.css"

const Patientdashboard = ({patientData, symptomCount = 0, selectedSubjectId}) => {
    const appData = useAppData()
    useEffect(() => {
     appData.setSelected("Patient Dashboard")
    }, [appData])
    
    // null = still loading; [] = loaded but empty
    const isLoading = patientData === null;
    const safePatientData = Array.isArray(patientData) ? patientData : [];

    return (
        <div data-testid="TGETIONROWDATA" id="scrollableDiv" style={{ height: '800px' }} className='patient_dash_container'>
            <IonGrid>
                {isLoading ?
                    <IonRow style={{height:'100%', alignItems:'center', justifyContent:'center'}}>
                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:'8px'}}>
                            <IonSpinner name="crescent" />
                            <div style={{fontSize:'14px', color:'#666'}}>Loading subjects...</div>
                        </div>
                    </IonRow>
                    : safePatientData.length === 0 ?
                    <IonRow style={{height:'100%', alignItems:'center', justifyContent:'center'}}>
                        <div style={{fontSize:'14px', color:'#666'}}>No subjects found for this site</div>
                    </IonRow>
                    : safePatientData.length > 0 ?
                    <IonRow  style={{paddingBottom:"200px"}}>
                        {safePatientData.map((item, index) => {
                            // Add safety check for item and attributes
                            if (!item || !item.attributes || !item.attributes.subjectId) {
                                return null;
                            }

                            // The card shows the last sync as a two-line
                            // day-over-month tile, so split the DD-MMM-YYYY
                            // string dashboard.jsx put on `timestamp`.
                            const [syncDay, syncMonth] = String(item?.timestamp || '').split('-');

                            return (
                                <IonCol data-testid={item.attributes.subjectId} key={item.attributes.subjectId} style={{ margin: '10px', }} size='auto'>
                                    <Patientcard
                                        patientData={item}
                                        subjectId={item.attributes.subjectId}
                                        batteryLife={item?.features?.batteryparameter?.properties?.['Battery Life Details']?.['Battery SOC (%)']}
                                        month={syncMonth || 'N/A'}
                                        day={syncDay || ''}
                                        implantDate={item?.implantDate}
                                        rriDate={item?.rriDate}
                                        eosDate={item?.eosDate}
                                        symptomCount={selectedSubjectId === item.attributes.subjectId ? symptomCount : 0}
                                    />
                                </IonCol>
                            )
                        })}
                    </IonRow> : <IonRow style={{height:'100%', alignItems:'center', justifyContent:'center'}}>
                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:'8px'}}>
                            <IonSpinner name="crescent" />
                            <div style={{fontSize:'14px', color:'#666'}}>No patient data available</div>
                        </div>
                    </IonRow>}
            </IonGrid>
        </div >
    )
}

export default Patientdashboard
